module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABT0lEQVRIibWW7XHCMAyGX3FdgBWyAh0hK2QFVoARYARW6ArpCGQEGIGO8PRHHOoqcj7u4L3LD9uSH0nWxTag1Z++Jf1I6sys0ytEWQ/gAtTvAuS6Aft3AgZdgd2a/Q04ZONa0k7SdsbvaGbntck8BeyAQypNSS0wF8gi2H4CdH0VZJsyWg8B6vTNRpLsHqsgzvDGTO+n84kglyUADwtBE5BmDeAZWZR+AfIY2S4AQKHGxAd/KpWqBk6F1KcgbWBbhZDkMNmSgX0V2B2ivZfUOHSmP6dct1nADKQK7Lzq3KChr2WL65q05jXqeca/k9OwsA82uDrnL7c+akf6BsnVlsiDmsw5KkHjAKNMJWkjqdRSz/l0P/s72vuN7nCg2qi/6CP5eT/+9xsxs3sU5EbSUf1LItc5eFV4m0X6MLMO+JQ01LQzsyirLgUzBTy68f0X3Ki0suoRdxYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2_wifi.png
// module id = GGhR
// module chunks = 1